import { render, staticRenderFns } from "./TeksSetter.vue?vue&type=template&id=4228eb1c&"
import script from "./TeksSetter.vue?vue&type=script&lang=js&"
export * from "./TeksSetter.vue?vue&type=script&lang=js&"
import style0 from "./TeksSetter.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TeksSetter.vue"
export default component.exports